var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "left-sidebar ex-bg-pink" }, [
      _c("nav", { staticClass: "navbar" }, [
        _c("ul", { staticClass: "navbar-nav align-items-center" }, [
          _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c(
                "router-link",
                {
                  staticClass: "nav-link",
                  attrs: { to: { path: "/admin/users" }, refresh: "" }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("sidebar_admin.users")) +
                      "\n                    "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.utils.isSystemAdmin()
            ? _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { path: "/admin/groups" }, refresh: "" }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sidebar_admin.groups")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.utils.isSystemAdmin()
            ? _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { path: "/admin/companies" }, refresh: "" }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sidebar_admin.companies")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.utils.isSystemAdmin()
            ? _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { path: "/admin/dmos" }, refresh: "" }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sidebar_admin.dmos")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.utils.isSystemAdmin()
            ? _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { path: "/admin/doc" }, refresh: "" }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sidebar_admin.doc")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.utils.isSystemAdmin()
            ? _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { path: "/admin/ocr" }, refresh: "" }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sidebar_admin.ocr")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.utils.isSystemAdmin()
            ? _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { path: "/admin/info" }, refresh: "" }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sidebar_admin.info")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-008cd9db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-008cd9db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/pc/SideBar.vue
// module id = null
// module chunks = 